import React, { useRef, useEffect } from 'react';
import card1 from '../assets/card 1.png';
import card2 from '../assets/card 2.png';
import card3 from '../assets/card 3.png';
import card4 from '../assets/card 4.png';
import card5 from '../assets/card 5.png';
import card6 from '../assets/card 6.png';
import card7 from '../assets/card 7.png';
import card8 from '../assets/card 8.png';
import card9 from '../assets/card 9.png';
import card10 from '../assets/card 10.png';
import card11 from '../assets/card 11.png';
import card12 from '../assets/card 12.png';
import heartsImage from '../assets/hearts image.png';

const HowItWorksSection: React.FC = () => {
  const carousel1Ref = useRef<HTMLDivElement>(null);
  const carousel2Ref = useRef<HTMLDivElement>(null);
  const howitworksRef = useRef<HTMLElement>(null);
  const carouselSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Add scroll reveal animations
    const howitworksEl = howitworksRef.current;
    const carouselSectionEl = carouselSectionRef.current;
    
    const observers: IntersectionObserver[] = [];
    
    if (howitworksEl) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              howitworksEl.classList.add('in-view');
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(howitworksEl);
      observers.push(observer);
    }
    
    if (carouselSectionEl) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              carouselSectionEl.classList.add('in-view');
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(carouselSectionEl);
      observers.push(observer);
    }
    
    // Add animations to carousels
    const carousel1 = carousel1Ref.current;
    const carousel2 = carousel2Ref.current;
    
    if (carousel1) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              carousel1.classList.add('in-view');
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(carousel1);
      observers.push(observer);
    }
    
    if (carousel2) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              carousel2.classList.add('in-view');
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(carousel2);
      observers.push(observer);
    }
    
    return () => {
      observers.forEach(obs => obs.disconnect());
    };
  }, []);

  useEffect(() => {
    const carousel1 = carousel1Ref.current;
    const carousel2 = carousel2Ref.current;
    if (!carousel1 || !carousel2) return;

    const handleMouseEnter = (element: HTMLElement) => {
      const container = element.querySelector('.carousel__container') as HTMLElement;
      if (!container) return;
      
      // Try to get animation and update playback rate
      const animations = container.getAnimations();
      if (animations && animations.length > 0) {
        const animation = animations[0];
        if (animation && typeof (animation as any).updatePlaybackRate === 'function') {
          (animation as any).updatePlaybackRate(0.5);
          return;
        }
      }
      
      // Fallback: pause animation
      container.style.animationPlayState = 'paused';
    };

    const handleMouseLeave = (element: HTMLElement) => {
      const container = element.querySelector('.carousel__container') as HTMLElement;
      if (!container) return;
      
      // Try to get animation and update playback rate
      const animations = container.getAnimations();
      if (animations && animations.length > 0) {
        const animation = animations[0];
        if (animation && typeof (animation as any).updatePlaybackRate === 'function') {
          (animation as any).updatePlaybackRate(1);
          return;
        }
      }
      
      // Fallback: resume animation
      container.style.animationPlayState = 'running';
    };

    const carousel1Enter = () => handleMouseEnter(carousel1);
    const carousel1Leave = () => handleMouseLeave(carousel1);
    const carousel2Enter = () => handleMouseEnter(carousel2);
    const carousel2Leave = () => handleMouseLeave(carousel2);

    carousel1.addEventListener('mouseenter', carousel1Enter);
    carousel1.addEventListener('mouseleave', carousel1Leave);
    carousel2.addEventListener('mouseenter', carousel2Enter);
    carousel2.addEventListener('mouseleave', carousel2Leave);

    return () => {
      carousel1.removeEventListener('mouseenter', carousel1Enter);
      carousel1.removeEventListener('mouseleave', carousel1Leave);
      carousel2.removeEventListener('mouseenter', carousel2Enter);
      carousel2.removeEventListener('mouseleave', carousel2Leave);
    };
  }, []);
  return (
    <>
      <section className="howitworks reveal" ref={howitworksRef}>
        <div className="howitworks__grid">
          <div className="howitworks__left">
            <div className="kicker"><span className="diamond" aria-hidden /> How it works</div>
            <h2 className="title-xl">Say hello to a new form of dating</h2>
            <img src={heartsImage} alt="" className="howitworks__hearts" />
          </div>
          <div className="howitworks__right">
            <p className="caption">
              Wrap is where real authentic connections grow. Answer daily photo or video prompts
              to keep your profile alive, and show who you are.
            </p>
            <button className="store-btn btn-lg btn--inverted btn--wide btn--arrow" type="button">Check it out</button>
          </div>
        </div>
      </section>
      <div className="carousel-section reveal" ref={carouselSectionRef}>
        <div className="carousel-section__kicker">
          <span className="carousel-section__circle" aria-hidden /> How wrap works
        </div>
        <h2 className="carousel-section__title">Prompts allow you to meet your significant other</h2>
      </div>
      <div className="howitworks__carousel reveal" ref={carousel1Ref}>
        <div className="carousel__container">
          <img src={card1} alt="Card 1" className="carousel__card" />
          <img src={card2} alt="Card 2" className="carousel__card" />
          <img src={card3} alt="Card 3" className="carousel__card" />
          <img src={card4} alt="Card 4" className="carousel__card" />
          <img src={card5} alt="Card 5" className="carousel__card" />
          <img src={card6} alt="Card 6" className="carousel__card" />
          <img src={card7} alt="Card 7" className="carousel__card" />
          <img src={card8} alt="Card 8" className="carousel__card" />
          <img src={card9} alt="Card 9" className="carousel__card" />
          <img src={card10} alt="Card 10" className="carousel__card" />
          <img src={card11} alt="Card 11" className="carousel__card" />
          <img src={card12} alt="Card 12" className="carousel__card" />
          <img src={card1} alt="Card 1" className="carousel__card" />
          <img src={card2} alt="Card 2" className="carousel__card" />
          <img src={card3} alt="Card 3" className="carousel__card" />
          <img src={card4} alt="Card 4" className="carousel__card" />
          <img src={card5} alt="Card 5" className="carousel__card" />
          <img src={card6} alt="Card 6" className="carousel__card" />
          <img src={card7} alt="Card 7" className="carousel__card" />
          <img src={card8} alt="Card 8" className="carousel__card" />
          <img src={card9} alt="Card 9" className="carousel__card" />
          <img src={card10} alt="Card 10" className="carousel__card" />
          <img src={card11} alt="Card 11" className="carousel__card" />
          <img src={card12} alt="Card 12" className="carousel__card" />
        </div>
      </div>
      <div className="howitworks__carousel howitworks__carousel--reverse reveal" ref={carousel2Ref}>
        <div className="carousel__container carousel__container--reverse">
          <img src={card7} alt="Card 7" className="carousel__card" />
          <img src={card12} alt="Card 12" className="carousel__card" />
          <img src={card3} alt="Card 3" className="carousel__card" />
          <img src={card9} alt="Card 9" className="carousel__card" />
          <img src={card1} alt="Card 1" className="carousel__card" />
          <img src={card5} alt="Card 5" className="carousel__card" />
          <img src={card11} alt="Card 11" className="carousel__card" />
          <img src={card4} alt="Card 4" className="carousel__card" />
          <img src={card8} alt="Card 8" className="carousel__card" />
          <img src={card2} alt="Card 2" className="carousel__card" />
          <img src={card10} alt="Card 10" className="carousel__card" />
          <img src={card6} alt="Card 6" className="carousel__card" />
          <img src={card7} alt="Card 7" className="carousel__card" />
          <img src={card12} alt="Card 12" className="carousel__card" />
          <img src={card3} alt="Card 3" className="carousel__card" />
          <img src={card9} alt="Card 9" className="carousel__card" />
          <img src={card1} alt="Card 1" className="carousel__card" />
          <img src={card5} alt="Card 5" className="carousel__card" />
          <img src={card11} alt="Card 11" className="carousel__card" />
          <img src={card4} alt="Card 4" className="carousel__card" />
          <img src={card8} alt="Card 8" className="carousel__card" />
          <img src={card2} alt="Card 2" className="carousel__card" />
          <img src={card10} alt="Card 10" className="carousel__card" />
          <img src={card6} alt="Card 6" className="carousel__card" />
        </div>
      </div>
    </>
  );
};

export default HowItWorksSection;


